import React from "react";
import PrivateNativeDate from "../PrivateNativeDate";
function DatePicker({ ...props }) {
    return React.createElement(PrivateNativeDate, { type: "date", ...props });
}
export default DatePicker;
//# sourceMappingURL=DatePicker.js.map